import {useDispatch} from 'react-redux';
import * as appActions from '../../../../store/actions/app';
import styles from './AlertModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import {colors} from '../../../../constants/colors';

function AlertModal({body, type}) {
    const dispatch = useDispatch();
    let background;

    if(type === 'error') {
        background = colors.red;
    } else {
        background = colors.secondary;
    }

    const handleClose = () => {
        dispatch(appActions.setAlertModal(false, ""));
    }

    return (
        <div className={styles.container} style={{backgroundColor: background}}>
            <FontAwesomeIcon className={styles.icon} icon={faTimes} size="1x" onClick={handleClose}/>
            <h4>{body}</h4>
        </div>
    )
}

export default AlertModal;
